<template>
  <div>
    <div>
      <h4 class="mb-8 mt-4 text-left text-dark-gray sm:mt-2">
        {{ header }}
      </h4>
      <!-- Second Time Through -->
      <div v-if="!firstTime">
        <div class="flex">
          <div class="mr-8 flex flex-col text-left">
            <p class="text-2xs font-bold uppercase text-gray-over-dark">
              Total Power Units
            </p>
            <p class="text-sm text-dark-gray">
              {{ data?.operations?.total_power_units || '-' }}
            </p>
          </div>
          <div class="mr-8 flex flex-col text-left">
            <p class="text-2xs font-bold uppercase text-gray-over-dark">
              Total Drivers
            </p>
            <p class="text-sm text-dark-gray">
              {{ data?.operations?.total_drivers || '-' }}
            </p>
          </div>
        </div>
        <div class="flex flex-col pt-8 text-left">
          <p class="text-2xs font-bold uppercase text-gray-over-dark">
            Trailer Types
          </p>
          <p class="text-sm text-dark-gray">
            {{ trailers }}
          </p>
        </div>
        <div class="flex flex-col pt-8 text-left">
          <p class="text-2xs font-bold uppercase text-gray-over-dark">Modes</p>
          <p class="text-sm capitalize text-dark-gray">
            {{ computedCarrierModes }}
          </p>
        </div>
        <div class="flex flex-col pt-8 text-left">
          <p class="text-2xs font-bold uppercase text-gray-over-dark">
            Specializations
          </p>
          <p class="text-sm text-dark-gray">
            {{ computedSpecializations }}
          </p>
        </div>
      </div>

      <!-- First Time Through -->
      <div v-if="firstTime && items">
        <div class="text-left">
          <!-- <p class="text-body-color">We source information on your Total Power Units and Total Drivers from FMCSA data (Form MCS-150).</p> -->
        </div>
        <div>
          <!-- Total Power Units, Total Drivers, Form Inputs -->
          <div class="flex gap-2 border-b border-light-gray pb-4">
            <span
              v-for="item in items.truck_information"
              :key="item"
              class="flex flex-grow text-left"
            >
              <form-field
                :label="item.name"
                :placeholder="item.placeholder"
                :value="data.operations ? data.operations[item.value] : ''"
                :name="item.value"
                pattern="number"
                @input="onUpdate"
              />
            </span>
          </div>
          <!-- Popular Trailer Types, Radio Buttons -->
          <div class="pt-6">
            <p
              v-if="title"
              class="mb-1 text-left text-2xs font-bold uppercase text-dark-blue"
            >
              Popular trailer Types (Required)
            </p>
            <div class="flex flex-wrap gap-2">
              <radio-button
                v-for="(item, index) in items.popular_trailer_types"
                :key="index"
                :class="buttonSize(index)"
                :item="item.name"
                :active="
                  data.popular_trailer_types?.find(
                    (el) => el.is_type === item.value
                  )
                "
                :handle-select="(e) => trailerTypeSelect(e, item.value)"
                name="popular_trailer_types"
              />
            </div>
          </div>
          <!-- Category Button Tags, Trailer Types -->
          <div class="flex flex-col pt-6">
            <p class="mb-1 text-2xs font-bold uppercase text-dark-blue">
              Other Trailer Types
            </p>
            <p class="pb-2 text-body-color">Tap on a tag to select</p>
            <div class="items-left flex flex-wrap">
              <label
                v-for="item in filterTags"
                :key="item.value"
                class="mb-2 mr-2 flex w-auto cursor-pointer rounded-full bg-light-gray px-4 py-2 text-sm text-dark-gray"
                :class="{
                  activeTag: data.popular_trailer_types?.find(
                    (el) => el.is_type === item.value
                  ),
                }"
              >
                <input
                  type="button"
                  class="focused-input cursor-pointer bg-transparent"
                  name="other_trailer_types"
                  :value="item.name"
                  @click="(e) => trailerTypeSelect(e, item.value, 'other')"
                />
                <img
                  v-if="
                    data.popular_trailer_types?.find(
                      (el) => el.is_type === item.value
                    )
                  "
                  class="pl-3"
                  src="@/assets/close-icon-white.svg"
                  alt="close-icon"
                />
              </label>
            </div>
          </div>

          <!-- Modes -->
          <div class="flex flex-col pt-6">
            <p class="mb-1 text-2xs font-bold uppercase text-dark-blue">
              Modes
            </p>
            <p class="pb-2 text-body-color">Tap on a tag to select</p>
            <div class="items-left flex flex-wrap">
              <label
                v-for="item in listOfAvailableModes"
                :key="item.value"
                class="mb-2 mr-2 flex w-auto cursor-pointer rounded-full bg-light-gray px-4 py-2 text-sm text-dark-gray"
                :class="{
                  activeTag: carrier_modes.find((el) => el === item.value),
                }"
              >
                <input
                  type="button"
                  class="focused-input cursor-pointer bg-transparent"
                  name="modes_of_operation"
                  :value="item.name"
                  @click="(e) => onCarrierModeSelect(e, item.value)"
                />
                <img
                  v-if="carrier_modes.find((el) => el === item.value)"
                  class="pl-3"
                  src="@/assets/close-icon-white.svg"
                  alt="close-icon"
                />
                <!--   <img
                  v-if="data.popular_trailer_types?.find(el => el.is_type === item.value)"
                  class="pl-3"
                  src="@/assets/close-icon-white.svg"
                  alt="close-icon"
                /> -->
              </label>
            </div>
          </div>

          <div class="pt-3">
            <p
              v-if="!seeMore"
              class="cursor-pointer text-yellow-500 underline"
              @click="seeMore = true"
            >
              See more
            </p>
          </div>

          <!-- Category Button Tags, Specializations -->
          <div
            v-if="seeMore"
            class="flex flex-col pt-4"
          >
            <p class="mb-1 text-2xs font-bold uppercase text-dark-blue">
              Specializations
            </p>
            <p class="pb-2 text-body-color">Tap on a tag to select</p>
            <div class="items-left flex flex-wrap">
              <label
                v-for="item in items.specializations"
                :key="item.value"
                class="mb-2 mr-2 flex w-auto cursor-pointer rounded-full bg-light-gray px-4 py-2 text-sm text-dark-gray"
                :class="{
                  activeTag: data.specializations?.find(
                    (el) => el.is_type === item.value
                  ),
                }"
              >
                <input
                  type="button"
                  class="focused-input cursor-pointer bg-transparent"
                  name="specializations"
                  :value="item.name"
                  @click="(e) => specializationSelect(e, item.value)"
                />
                <img
                  v-if="
                    data.specializations?.find(
                      (el) => el.is_type === item.value
                    )
                  "
                  class="pl-3"
                  src="@/assets/close-icon-white.svg"
                  alt="close-icon"
                />
              </label>
            </div>
          </div>
          <div class="pt-3">
            <p
              v-if="seeMore"
              class="cursor-pointer text-yellow-500 underline"
              @click="seeMore = false"
            >
              See less
            </p>
          </div>
        </div>
      </div>
    </div>
    <form-navigation-buttons
      v-if="!isNavigationDisabled"
      :enabled="!isNavigationDisabled"
      :component-identifier="componentIdentifier"
      :buttons-to-display="buttonsToDisplay"
      :is-button-disabled="isButtonDisabled"
      @next="handleNext"
      @back="handleBack"
      @edit="handleEdit"
      @exit-modal="emitExitModal"
    />
  </div>
</template>

<script>
import FormNavigationButtons from '@/components/FormNavigationButtons.vue';
import { useFormRouter } from '@/composables/formRouter';
import { useStore } from 'vuex';
import { computed } from 'vue';
import moment from 'moment';
import stepInformation from '@/common/stepInformation';
import RadioButton from '@/components/RadioButton.vue';
import FormField from '@/components/FormField.vue';
import { capitalize } from '@/common/validators';
import { toastResponse } from '@/common/handleServerResponse';
import _ from 'lodash';

export default {
  name: 'Operations',
  components: {
    RadioButton,
    FormField,
    FormNavigationButtons,
  },
  props: {
    data: Object,
    updateField: Function,
    nextStep: Function,
    formPosition: Number,
    title: String,
    stepName: String,
    skipStep: Function,
    screenSize: String,
  },
  setup(props, { emit }) {
    const store = useStore();
    const componentIdentifier = 'Operations';
    const formRouter = useFormRouter(componentIdentifier);
    const isNavigationDisabled = computed(() => formRouter.isDisabled.value);
    const firstTime = computed(
      () =>
        store.state.firstTime?.[
          formRouter.componentStep.value?.firstTimeIdentifier
        ]
    );
    const buttonsToDisplay = computed(() => {
      if (firstTime.value) return 'continue-save';
      return 'continue-edit';
    });
    const skipSubstepsThreeAndFourIdentity = computed(() => {
      if (
        import.meta.env.VITE_DISABLE_RATE_CON_AND_INVOICING_CONTACT_STEPS == 1
      ) {
        return true;
      }
      return (
        store.state.carriers.carrierDetails?.authority?.authorities
          ?.broker_authority_status !== 'Active'
      );
    });
    const isButtonDisabled = false;

    const handleNext = () => {
      store.commit(
        'addFormDebugMessage',
        componentIdentifier + ": 'handleNext' called"
      );
      if (isNavigationDisabled.value)
        return store.commit(
          'addFormDebugMessage',
          'ERROR: ' +
            componentIdentifier +
            ': formRouter is disabled, returning'
        );
      formRouter.moveToNextStep();
    };

    const handleBack = () => {
      store.commit(
        'addFormDebugMessage',
        componentIdentifier + ": 'handleBack' called"
      );
      if (isNavigationDisabled.value)
        return console.log(
          'ERROR: ' +
            componentIdentifier +
            ': formRouter is disabled, returning'
        );

      if (skipSubstepsThreeAndFourIdentity.value) {
        formRouter.moveToStepByIdentifier('Identity-2');
      } else {
        formRouter.moveToPreviousStep();
      }
    };

    const handleEdit = () => {
      store.commit(
        'addFormDebugMessage',
        componentIdentifier + ": 'handleEdit' called"
      );
      if (isNavigationDisabled.value)
        return console.log(
          'ERROR: ' +
            componentIdentifier +
            ': formRouter is disabled, returning'
        );
      formRouter.editActiveStep();
    };

    const date = new Date();
    const currentDate = moment(date, 'YYYY-MM-DD').format('YYYY-MM-DD');

    const updatePacketBody = (body) => {
      store.dispatch('onboardingPacket/setOnboardingBody', {
        carrier: {
          ...store.state.onboardingPacket.onboardingPacketBody.carrier,
          ...body,
        },
      });
    };

    const checkData = () => {
      if (props.data.popular_trailer_types.length > 0) {
        store.commit('toggleDisabledButton', {
          bool: false,
          source: 'Operations #1',
        });
      } else {
        store.commit('toggleDisabledButton', {
          bool: true,
          source: 'Operations #2',
        });
      }
    };

    const trailerTypeSelect = (e, val, type) => {
      const currentPacketArr =
        store.state.onboardingPacket.onboardingPacketBody.carrier
          ?.equipment_types_attributes || [];
      // Find existing trailer information -- return if file_date is before today's date
      const existingTrailers =
        store.state.carriers.carrierData.operations.equipment_types
          .filter((el) => {
            const today = moment();
            const dateIsBefore = moment(el.created_at).isBefore(today); // true

            return (
              dateIsBefore &&
              !currentPacketArr.find((item) => item.el === el.is_type)
            );
          })
          .map((e) => {
            // return e.is_type;
            return {
              equipment_typeable_type: 'OnboardingPacket',
              is_type: e.is_type,
              file_date: currentDate,
              equipment_typeable_id: store.state.carriers.carrierData.id,
            };
          });

      let trailerArr = [];
      //update props
      if (val === "I don't use any of the above trailers") {
        const updatePopularTrailers = props.data.popular_trailer_types.filter(
          (el) =>
            el.is_type !== 'van' &&
            el.is_type !== 'reefer' &&
            el.is_type !== 'flatbed'
        );

        props.updateField('popular_trailer_types', [
          ...updatePopularTrailers,
          { is_type: "I don't use any of the above trailers" },
        ]);
        // check if there any existing value in the current equipment_types
        // remove them if there
        const mappedDestoryItems = [];
        store.state.carriers.carrierData.operations.equipment_types.forEach(
          (el) => {
            if (
              el.is_type === 'van' ||
              el.is_type === 'reefer' ||
              el.is_type === 'flatbed'
            ) {
              mappedDestoryItems.push({
                id: el.id,
                _destroy: 1,
              });
            }
          }
        );
        trailerArr = [...currentPacketArr, ...mappedDestoryItems];
      } else if (
        props.data.popular_trailer_types.find((el) => el.is_type === val)
      ) {
        // Removes item that is de-selected

        // check that the de-selected value exists currently in the equipment types
        // AND doesn't already exist in the onboardingbody
        // find ID of item
        // Destroy with the ID
        const findItem =
          store.state.carriers.carrierData.operations.equipment_types?.find(
            (el) => el.is_type === val
          );

        const filteredArr =
          currentPacketArr.length === 0 ? existingTrailers : currentPacketArr;

        const alreadyDeselected = currentPacketArr.find(
          (el) => el.is_type === val
        );
        const selectedItem = findItem || alreadyDeselected;
        const filteredExisting = filteredArr.filter(
          (el) => el.is_type !== selectedItem.is_type
        );

        if (findItem) {
          trailerArr = [
            ...filteredExisting,
            {
              id: findItem.id,
              is_type: val, // value here (snake_case)
              _destroy: 1,
            },
          ];
        } else {
          trailerArr = filteredExisting;
        }

        const updatedArray = props.data.popular_trailer_types.filter(
          (item) => item.is_type !== val
        );
        props.updateField('popular_trailer_types', updatedArray);
      } else {
        // Adds selected item
        const filteredArr = props.data.popular_trailer_types?.filter((el) => {
          if (type !== 'other') {
            return el.is_type !== "I don't use any of the above trailers";
          } else {
            return el;
          }
        });
        props.updateField('popular_trailer_types', [
          ...filteredArr,
          { is_type: val },
        ]);

        // add value to onboarding body
        // remove destroy from list (if there)
        const isAlreadySelected =
          store.state.onboardingPacket.onboardingPacketBody.carrier?.equipment_types_attributes?.find(
            (el) => el.is_type === val
          );
        const existingItems =
          currentPacketArr.length === 0 ? existingTrailers : currentPacketArr;
        if (isAlreadySelected) {
          const filteredArray = existingTrailers.filter(
            (el) => el.id !== isAlreadySelected.id
          );
          trailerArr = filteredArray;
        } else {
          // item not already in payload

          const combinedArr = [
            ...existingItems,
            {
              equipment_typeable_type: 'OnboardingPacket',
              equipment_typeable_id: store.state.carriers.carrierData.id,
              is_type: val, // value here (snake_case)
              file_date: currentDate,
            },
          ];

          trailerArr = [...new Set(combinedArr)];
        }
      }

      // create body of request
      updatePacketBody({
        equipment_types_attributes: trailerArr,
      });

      checkData();
    };

    const specializationSelect = (e, val) => {
      const currentSpecializationsArr =
        store.state.onboardingPacket.onboardingPacketBody.carrier
          ?.specializations_attributes || [];

      const existingSpecializations =
        store.state.carriers.carrierData.operations.specializations
          .filter((el) => {
            const today = moment();
            const dateIsBefore = moment(el.created_at).isBefore(today); // true

            return (
              dateIsBefore &&
              !currentSpecializationsArr.find((item) => item.el === el.is_type)
            );
          })
          .map((e) => {
            return {
              specializationable_type: 'OnboardingPacket',
              specializationable_id: store.state.carriers.carrierData.id,
              is_type: e.is_type,
              file_date: currentDate,
            };
          });

      // update specialization props
      const specializationsArr =
        currentSpecializationsArr.length > 0
          ? currentSpecializationsArr
          : existingSpecializations;
      const itemExists = specializationsArr.find((el) => el.is_type === val);

      if (props.data.specializations.find((el) => el.is_type === val)) {
        // remove item
        const filteredPacket = specializationsArr.filter(
          (el) => el.is_type !== itemExists.is_type
        );
        const itemCurrentlyOnPacket =
          store.state.carriers.carrierData.operations.specializations.find(
            (el) => el.is_type === val
          );

        if (itemCurrentlyOnPacket) {
          const body = {
            specializations_attributes: [
              ...filteredPacket,
              {
                id: itemCurrentlyOnPacket.id,
                is_type: val,
                _destroy: 1,
              },
            ],
          };
          updatePacketBody(body);
        } else {
          const body = {
            specializations_attributes: filteredPacket,
          };
          updatePacketBody(body);
        }

        const updatedArray = props.data.specializations.filter(
          (item) => item.is_type !== val
        );
        props.updateField('specializations', updatedArray);
      } else {
        props.updateField('specializations', [
          ...props.data.specializations,
          { is_type: val },
        ]);

        const filtered = specializationsArr.filter((el) => {
          if (el.is_type === val && el._destroy === 1) {
            return false;
          } else {
            return el;
          }
        });

        // create body of request
        const body = {
          // ...store.state.onboardingPacket.onboardingPacketBody.carrier,
          specializations_attributes: [
            ...(filtered || []),
            {
              specializationable_type: 'OnboardingPacket',
              specializationable_id: store.state.carriers.carrierData.id,
              is_type: val, // value here
              file_date: currentDate,
            },
          ],
        };
        updatePacketBody(body);
      }

      checkData();
    };

    const onUpdate = (e) => {
      props.updateField(e.target.name, e.target.value);

      if (e.target.name === 'total_drivers') {
        // Update total drivers
        const body = {
          ...store.state.onboardingPacket.onboardingPacketBody.carrier,
          drivers_attributes: [
            {
              driverable_type: 'OnboardingPacket',
              driverable_id: store.state.carriers.carrierData.id, // ID of the onboarding packet
              total_drivers: e.target.value, // value changing
              file_date: currentDate, // current date in this format
            },
          ],
        };
        updatePacketBody(body);
      } else {
        // Update total power units
        const body = {
          ...store.state.onboardingPacket.onboardingPacketBody.carrier,
          equipments_attributes: [
            {
              equipmentable_type: 'OnboardingPacket',
              equipmentable_id: store.state.carriers.carrierData.id,
              total_power_units: e.target.value, // value to change
              file_date: currentDate,
            },
          ],
        };
        updatePacketBody(body);
      }
    };

    const emitExitModal = () => {
      store.commit(
        'addFormDebugMessage',
        componentIdentifier + ": 'emitExitModal' called"
      );
      emit('exit-modal');
    };

    return {
      componentIdentifier,
      handleNext,
      handleBack,
      handleEdit,
      buttonsToDisplay,
      isButtonDisabled,
      isNavigationDisabled,
      firstTime,
      trailerTypeSelect,
      specializationSelect,
      onUpdate,
      emitExitModal,
    };
  },
  data() {
    return {
      items: null,
      seeMore: false,
      tags_number: 12,
      specializations: [],
      carrier_modes: [],
    };
  },
  computed: {
    filterTags: function () {
      if (!this.seeMore) {
        return _.orderBy(
          this.items?.other_trailer_types?.slice(0, this.tags_number),
          'name'
        );
      } else {
        return _.orderBy(this.items?.other_trailer_types, 'name');
      }
    },
    listOfAvailableModes: function () {
      if (!this.items?.modes?.length) return [];
      return _.orderBy(this.items.modes, 'name');
    },
    header: function () {
      if (this.firstTime) {
        return 'Tell us about your equipment and modes. We source some of this information from FMCSA data (Form MCS-150), if available.';
      } else {
        return 'Confirm these details about your operations.';
      }
    },
    trailers: function (props) {
      const combinedTrailerTypes = props.data.popular_trailer_types.concat(
        props.data.other_trailer_types
      );
      let filteredCombinedTrailerTypes = combinedTrailerTypes.filter((el) => {
        // Handle the case when there aren't items.
        if (!this.items?.popular_trailer_types) return false;
        let item = this.items.popular_trailer_types
          .concat(this.items.other_trailer_types)
          .find((ele) => ele.value === el.is_type);
        return !!item;
      });

      if (filteredCombinedTrailerTypes.length > 0 && this.items) {
        const combinedTrailerTypesForItems =
          this.items.popular_trailer_types.concat(
            this.items.other_trailer_types
          );
        return combinedTrailerTypes
          .map((el) => {
            const item = combinedTrailerTypesForItems.find(
              (ele) => ele.value === el.is_type
            );
            return item?.name ? capitalize(item.name) : '';
          })
          .filter((el) => el !== '') // Do not show empty data
          .join(', ');
      } else {
        return '-';
      }
    },
    computedSpecializations: function (props) {
      if (props.data.specializations.length && this.items) {
        let filteredSpecializations = props.data.specializations.filter(
          (el) => {
            let item = this.items.specializations.find(
              (ele) => ele.value === el.is_type
            );
            return !!item;
          }
        );
        return filteredSpecializations
          .map((el) => {
            const item = this.items.specializations.find(
              (ele) => ele.value === el.is_type
            );
            if (item && item?.name) return capitalize(item.name);
            return '';
          })
          .join(', ');
      } else {
        return ' - ';
      }
    },
    carrierId() {
      return (
        this.$store.state.carriers?.carrierDetails?.id ||
        this.$store.state.users?.currentUser?.company?.carrier_id ||
        ''
      );
    },
    computedCarrierModes() {
      if (this.carrier_modes?.length > 0) {
        if (
          this.carrier_modes?.length == 1 &&
          this.carrier_modes[0] == 'none_selected'
        ) {
          return '-';
        } else {
          return this.carrier_modes?.join(', ')?.replace('_', ' ');
        }
      } else if (this.initialCarrierModesList?.length > 0) {
        return this.initialCarrierModesList?.join(', ')?.replace('_', ' ');
      } else {
        return '-';
      }
    },
    /**
     * This function returns the last list of carrier modes that was saved by the API endpoint.
     */
    initialCarrierModesList() {
      if (!this.$store.state.carriers?.carrierData?.carrier_modes?.length) {
        return [];
      }
      const carrierModesList =
        this.$store.state.carriers.carrierData.carrier_modes.map((mode) => {
          return mode.is_type;
        });
      /** Do not return duplicated values */
      return _.uniq(carrierModesList, function (type) {
        return type;
      });
    },
  },
  watch: {
    stepName: function (val) {
      if (val === 'Operations') {
        if (
          this.carrierId > 0 &&
          Object.keys(this.$store.state.carriers?.carrierDetails)?.length === 0
        ) {
          console.log('carrierId from stepName watch');
          console.dir(this.carrierId);
          this.$store.dispatch('carriers/getCarriersDetail', {
            id: this.carrierId,
          });
        }
        // const find = document.querySelector("#total_power_units");
        // setTimeout(() => {
        //   if (find) {
        //     find.focus();
        //   }
        // }, 0);

        this.$props.updateField(
          'specializations',
          this.$store.state.carriers.carrierData.operations.specializations
        );
        this.$props.updateField(
          'popular_trailer_types',
          this.$store.state.carriers.carrierData.operations.equipment_types
        );

        if (this.firstTime && this.data?.popular_trailer_types.length === 0) {
          this.$store.commit('toggleDisabledButton', {
            bool: true,
            source: 'Operations #3',
          });
        } else {
          this.$store.commit('toggleDisabledButton', {
            bool: false,
            source: 'Operations #4',
          });
        }
      }
    },
    carrierId: function (val) {
      if (
        val > 0 &&
        Object.keys(this.$store.state.carriers?.carrierDetails)?.length === 0
      ) {
        this.$store.dispatch('carriers/getCarriersDetail', { id: val });
      }
    },
    screenSize: function (val) {
      if (val === 'mobile') {
        this.tags_number = 12;
      } else {
        this.tags_number = 22;
      }
    },
  },
  mounted() {
    this.carrier_modes = this.initialCarrierModesList;
    this.items = stepInformation.operations;
    if (this.screenSize !== 'mobile') {
      this.tags_number = 22;
    }
  },
  async created() {
    // console.log("Comes!")
    // await this.$store.dispatch('carriers/getCarriersDetail', {id: this.$store.state.users.currentUser.requested_carrier_id})
  },
  methods: {
    buttonSize: function (index) {
      if (index === 0) {
        return 'w-1/4 md:w-1/4';
      } else if (index === 1) {
        return 'md:w-1/4';
      } else if (index === 2) {
        return 'md:w-1/4';
      } else {
        return 'md:w-full';
      }
    },
    async updateCarrierModes() {
      const body = {
        carrier_modes: {
          carrier_id: this.carrierId,
          is_types: this.carrier_modes,
        },
      };
      let response = await this.$store.dispatch(
        'carriers/updateCarrierModesOfOperation',
        body
      );
      console.dir(response);
      if (![200, 201].includes(response?.status)) {
        toastResponse(this, response, null);
      }
    },
    onCarrierModeSelect(e, value) {
      if (
        this.carrier_modes?.length == 1 &&
        this.carrier_modes[0] == 'none_selected'
      ) {
        this.carrier_modes = [];
      }
      const modeExist = this.carrier_modes.find((mode) => mode === value);
      if (!modeExist) this.carrier_modes.push(value);
      else
        this.carrier_modes = this.carrier_modes.filter(
          (mode) => mode !== modeExist
        );
      this.updateCarrierModes();
    },
  },
};
</script>
<style scoped>
p {
  @apply text-left;
}

.activeTag {
  @apply bg-yellow-500 text-white;
}

.focused-input:focus {
  outline: none !important;
  border: none !important;
}
</style>
